/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'http://cprp-demo-api.geodemosolutions.com/public/'
  baseApiUrl = 'https://commenting-tool-demo-api-fivedocks.geodemosolutions.com/public/'
  // baseApiUrl = 'https://commenting-tool-demo-api.geodemosolutions.com/public/'
 }
else {
  baseApiUrl = 'http://localhost/cprp-demo-api/public/'
}

export {
  baseApiUrl
}
